import React, {useEffect, useState} from "react";
import { Column, Text } from "@amzn/meridian";
import { useAppSelector, useAppDispatch } from "src/store/store";
import BarcodeFrame from "../../barcodeScanner/BarcodeFrame";
import { setScreenDimensions } from "src/store/inspectionCaptureSlice";
import { setShownHumanText } from "src/store/workflowSlice";
import StepTransitionSheet from "./StepTransitionSheet";

interface ReadBarcodeStepProps {
  humanText: string;
  onComplete: () => void;
}

const ReadBarcodeStep: React.FC<ReadBarcodeStepProps> = ({
  humanText,
  onComplete,
}) => {
  const dispatch = useAppDispatch();
  const [stepComplete, setStepComplete] = useState(false);
  const { screenWidth, screenHeight } = useAppSelector((state) => state.inspectionCapture);
  useEffect(() => {
      dispatch(setShownHumanText(humanText));
      const updateScreenDimensions = () => {
        const screenW = window.screen.width;
        const screenH = window.screen.height;
        
        // Use device pixel ratio, but force 3x for screens smaller than 1080p
        // This ensures mobile devices and small screens get high-resolution camera
        let pixelRatio = window.devicePixelRatio || 1;
        if (screenW < 1920 || screenH < 1080) {
          pixelRatio = 3;
        }
        
        let cameraWidth = Math.floor(screenW * pixelRatio);
        let cameraHeight = Math.floor(screenH * pixelRatio);
        
        // Swap to landscape orientation for camera (always wider than tall)
        // This prevents zoom issues on portrait devices while maintaining high resolution
        const isPortrait = cameraHeight > cameraWidth;
        if (isPortrait) {
          [cameraWidth, cameraHeight] = [cameraHeight, cameraWidth];
        }
        
        dispatch(setScreenDimensions({
          width: cameraWidth,
          height: cameraHeight,
        }));
      };
      
      // Initial capture
      updateScreenDimensions();
      
      // Update on window resize
      window.addEventListener('resize', updateScreenDimensions);
      
      return () => {
        window.removeEventListener('resize', updateScreenDimensions);
      };
    }, []);
  return (
    <Column height="100vh">
      <BarcodeFrame onBarcodeConfirmed={() => setStepComplete(true)} idealHeight={screenHeight > 0 ? screenHeight : 1080} idealWidth={screenWidth > 0 ? screenWidth : 1920} />
      { stepComplete && <StepTransitionSheet
        headerMessage="Barcode Scanned."
        message="Get ready to focus container."
        onClose={onComplete}
      />}
    </Column>
  );
};

export default ReadBarcodeStep;
